import { watch, onUnmounted } from 'vue';
import { useSystemStore } from '../stores/system';
import { brand } from '../config/brand';

/**
 * Composable that keeps the browser tab title in sync with the system name.
 * Also updates the apple-mobile-web-app-title meta tag for iOS.
 */
export function useDocumentTitle() {
  const system = useSystemStore();

  function updateTitle(name: string) {
    const title = name || brand.agentName;
    document.title = title;

    // Update Apple mobile web app title meta tag
    const appleMeta = document.querySelector('meta[name="apple-mobile-web-app-title"]');
    if (appleMeta) {
      appleMeta.setAttribute('content', title);
    }
  }

  // Update immediately if already loaded
  if (system.name) {
    updateTitle(system.name);
  }

  // Watch for changes
  const stopWatch = watch(
    () => system.name,
    (newName) => {
      updateTitle(newName);
    },
  );

  onUnmounted(() => {
    stopWatch();
  });

  return { updateTitle };
}
